import { NavLink, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import BrandLogos from "@/components/BrandLogos";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/owner", label: "Owner", testid: "nav-owner-link" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const solidBg = "bg-black";
  const scrolledBg =
    "bg-black/85 backdrop-blur-xl border-b border-white/15";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? scrolledBg : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-28 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand-logo"
          className="flex items-center group"
          onClick={() => setOpen(false)}
        >
          <BrandLogos variant="navbar" />
        </Link>

        <nav className="hidden md:flex items-center gap-10 ml-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `na-link text-sm tracking-[0.2em] uppercase font-medium ${
                  isActive ? "active text-[#ffd36e]" : "text-white/90"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} strokeWidth={1.25} /> : <Menu size={22} strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className={`md:hidden ${solidBg} border-t border-white/15`}
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-serif-display text-3xl ${
                    isActive ? "text-[#cfa86e]" : "text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
